import domain from "./DomainService";

/**
 * Get the user's engagement data to display on EngagementPage
 * Uses JWT token to identify user
 * @return {Promise}
 */
export default function GetEngagement() {
  const token = localStorage.getItem("token");
  const options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "JWT " + token,
    },
  };
  let pod_id = "TIC1";

  return fetch(domain() + "engagement?pod_id=" + pod_id, options);
}
